export const MESSAGE_TEMPLATE_PREVIEW_LENGTH = 100;

function stripMarkup(input: string) {
  return input
    .replace(/<[^>]*>/g, " ")
    .replace(/!\[[^\]]*\]\([^)]*\)/g, " ")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/`{1,3}[^`]*`{1,3}/g, " ")
    .replace(/[*_~]/g, " ")
    .replace(/^>\s?/gm, " ")
    .replace(/^\s*[-+*]\s+/gm, " ")
    .replace(/#+\s*/g, " ");
}

export function normalizePreviewText(input?: string | null) {
  if (!input) return "";

  return stripMarkup(input).replace(/\s+/g, " ").trim();
}

export function getMessageTemplatePreviewSnippet(input?: string | null) {
  const normalized = normalizePreviewText(input);
  if (!normalized) return "";

  return normalized.slice(0, MESSAGE_TEMPLATE_PREVIEW_LENGTH);
}
